export default {
  type: 'GPS',
  gps_accuracy: 100,
  gps_timeout: 10000,
  web_visibility: 0,
  zoom_level: 4,
  gps_display_type: 0
};